var _rect, _rect2, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 128,
    viewBox: "0 0 177 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 128,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -211,
    y: -183,
    width: 600,
    height: 550,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2788 10.3842C-21.8608 40.9203 13.3598 83.1357 35.9875 100.426C67.7354 124.686 141.152 147.906 171.676 100.426C205.576 47.6942 68.4534 -27.7858 18.2788 10.3842Z",
    fill: "#F4F5F7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.7646,
    cy: 44.2641,
    rx: 12.3017,
    ry: 12.2641,
    fill: "#B8B8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4217 82.9432C98.4217 79.9699 97.8343 77.0257 96.693 74.2787C95.5516 71.5317 93.8788 69.0357 91.7699 66.9333C89.661 64.8308 87.1573 63.1631 84.4019 62.0252C81.6465 60.8874 78.6933 60.3018 75.7109 60.3018C72.7284 60.3018 69.7752 60.8874 67.0198 62.0252C64.2644 63.1631 61.7608 64.8308 59.6519 66.9333C57.543 69.0357 55.8701 71.5317 54.7288 74.2787C53.5874 77.0257 53 79.9699 53 82.9432L98.4217 82.9432Z",
    fill: "#B8B8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.425 99.8405L114.908 105",
    stroke: "#FF725E",
    strokeWidth: 0.959065,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.767 92.1036L124 93.4676",
    stroke: "#FF725E",
    strokeWidth: 0.959065,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.133 96.6291L120.947 100.804",
    stroke: "#FF725E",
    strokeWidth: 0.959065,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3961 64.0068C86.3961 60.6522 89.1155 57.9327 92.4702 57.9327H103.84C107.195 57.9327 109.914 60.6522 109.914 64.0068V75.7378H86.3961V64.0068Z",
    stroke: "black",
    strokeWidth: 1.91813
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9033 75.9863C81.9033 74.0442 83.4777 72.4697 85.4199 72.4697H110.182C112.124 72.4697 113.699 74.0441 113.699 75.9863V91.495C113.699 93.8256 111.809 95.7149 109.479 95.7149H86.1232C83.7926 95.7149 81.9033 93.8256 81.9033 91.495V75.9863Z",
    fill: "#83A9FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.1544,
    cy: 85.8583,
    rx: 2.11968,
    ry: 2.1132,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.4482,
    y: 87.2676,
    width: 1.41255,
    height: 3.522,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIllustration);
export default __webpack_public_path__ + "static/media/inactive-illustration.f93e581489f1813cb2498c7033c0ed7c.svg";
export { ForwardRef as ReactComponent };